import { UserRole } from 'pages/User/constants'

export const AppRouteURI = Object.freeze({
    HOME: '/',
    SEVENSCREEN: '/7screen',
    LOGIN: '/login',
    TWO_FACTOR: '/two_factor',
    // OKTALOGIN: '/oktalogin',
    LOGOUT: '/logout',
    REGISTER: '/register',
    RESET_PWD: '/reset_password',
    INVITATION: '/invitation',
    MEMBERS: '/members',
    // SECURITY: '/security',
    SETTINGS: '/settings',
    INVITES: '/invites',
    VERIFY_EMAIL: '/verify_email',
    ANALYTICS: '/analytics',
    // GROUPS: '/groups',
    // PERMISSIONS: '/permissions',
})

export const AppRoutingRoles = Object.freeze({
    [AppRouteURI.HOME]: {
        isProtected: false,
        checkRoles: [],
    },
    [AppRouteURI.SEVENSCREEN]: {
        isProtected: false,
        checkRoles: [],
    },
    [AppRouteURI.MEMBERS]: {
        isProtected: true,
        checkRoles: [UserRole.ADMIN, UserRole.ADMIN],
    },
    [AppRouteURI.INVITES]: {
        isProtected: true,
        checkRoles: [UserRole.ADMIN, UserRole.ADMIN],
    },
    [AppRouteURI.ANALYTICS]: {
        isProtected: true,
        checkRoles: [UserRole.ADMIN, UserRole.ADMIN],
    },
    // [AppRouteURI.GROUPS]: {
    //     isProtected: true,
    //     checkRoles: [UserRole.ADMIN, UserRole.ADMIN],
    // },
    // [AppRouteURI.PERMISSIONS]: {
    //     isProtected: true,
    //     checkRoles: [UserRole.ADMIN, UserRole.ADMIN],
    // },
    // [AppRouteURI.SECURITY]: {
    //     isProtected: true,
    //     checkRoles: [UserRole.ADMIN],
    // },
    [AppRouteURI.SETTINGS]: {
        isProtected: true,
        checkRoles: [],
    },
    [AppRouteURI.LOGOUT]: {
        isProtected: false,
        checkRoles: [],
    },
})
